import React from "react";

function BackIcon({ fill }) {
  return (
    <>
      <svg
        width="11"
        height="8"
        viewBox="0 0 11 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.76933 7.53833L0 3.76917L3.76933 0L4.47183 0.723L1.92567 3.26917H10.2693V4.26917H1.92567L4.47183 6.81533L3.76933 7.53833Z"
          fill={fill}
        />
      </svg>
    </>
  );
}

export default BackIcon;
